

/*
vim: fileformat=unix syntax=JavaScript tabstop=4 shiftwidth=4 expandtab fileencoding=utf8
*/
/* jslint browser: true */

//warning!! this file is also shared and used inside demo page, see uniwizard-lib.js
//be careful when changing
import $ from 'jquery';
import moment from 'moment';

import { getTranslator } from '../js/i18n';
import tools from '../js/tools';

const t = getTranslator();

const FILTER_WACOM = 1;
const FILTER_MOUSE = 2;
const FILTER_PEN = 4;
//touch is unused here, basically all touch events are treated as mouse events, see mouse.js
const FILTER_TOUCH = 8;
const FILTER_WACOM_EXT = 16;
const FILTER_POINTER = FILTER_MOUSE | FILTER_PEN;
const FILTER_POINTER_ALL_INTERNAL = FILTER_POINTER | FILTER_TOUCH;
const FILTER_ALL = FILTER_WACOM | FILTER_WACOM_EXT | FILTER_POINTER;

function getFilterString(filter) {
    if((filter & FILTER_ALL) == FILTER_ALL) {
        return t('utils.any');
    }
    if(((filter & FILTER_POINTER) == FILTER_POINTER)
            || ((filter & FILTER_POINTER_ALL_INTERNAL) == FILTER_POINTER_ALL_INTERNAL)) {
        return t('utils.wintab_or_mouse');
    }

    if(filter & FILTER_WACOM_EXT) {
        return 'Wacom STU';
    }
    if(filter & FILTER_WACOM) {
        return 'Wacom STU (ActiveX mode)';
    }
    if(filter & FILTER_PEN) {
        return 'WinTab';
    }
    if(filter & FILTER_MOUSE) {
        return 'Mouse';
    }
    if(filter & FILTER_TOUCH) {
        return 'Touch screen';
    }
    return '';
}

function PreserveVariables(wizprops, wizardSharedState) {
    const preserveFields = {};
    let preservedValues = {};
    const preservedControls = {};
    function init() {
        const exData = wizprops.signatureExData;
        if(!exData || !exData.preserveFields)
            return;
        const fields = exData.preserveFields;
        for(let i = 0; i < fields.length; i++) {
            preserveFields[fields[i]] = true;
        }

        preservedValues = wizardSharedState.preservedValues || {};
    }
    this.getValue = function(ctlname, ctl, name, value) {
        if(!preserveFields[name])
            return value;
        preservedControls[ctlname] = { name, ctl };
        if((preservedValues[name] === undefined) || (preservedValues[name] === null))
            return value;
        return preservedValues[name];
    };
    this.savePreservedState = function(type) {
        type += '.';
        for(const ctlname in preservedControls) {
            if(ctlname.lastIndexOf(type, 0) !== 0)
                continue;
            const ctldef = preservedControls[ctlname];
            const ctl = ctldef.ctl;
            let value;
            switch(ctl.attr('type')) {
                case 'checkbox':
                    value = ctl.prop('checked') ? 'true' : 'false';
                    break;
                default:
                    value = ctl.val();
            }
            preservedValues[ctldef.name] = value;
        }
        wizardSharedState.preservedValues = preservedValues;
    };
    init();
}

function ImageUrl(bitmapurl, params0) {
    this.bitmapurl = bitmapurl;
    this.params = params0;
    this.construct = function(params) {
        for(const name in this.params) {
            if(params[name] === undefined)
                params[name] = this.params[name];
        }
        const url = this.bitmapurl + '&def=' + encodeURIComponent(JSON.stringify(params));
        return url;
    };
}

function Rectangle(x, y, width, height) {
    this.x = x;
    this.y = y;
    this.width = width;
    this.height = height;

    this.contains = function(pt) {
        if(((pt.x >= this.x) && (pt.x <= (this.x + this.width)))
            && ((pt.y >= this.y) && (pt.y <= (this.y + this.height)))) {
            return true;
        }
        return false;
    };
}

// In order to simulate buttons, we have our own Button class that stores the bounds and event handler.
// Using an array of these makes it easy to add or remove buttons as desired.
//  delegate void ButtonClick();

function Button() {
    this.bounds = undefined; // in Screen coordinates
    this.text = undefined;
    this.image = undefined;
    this.click = undefined;
}

function Point(x, y) {
    this.x = x;
    this.y = y;
}

function Buttons() {
    const buttons = [];
    function initButton(btn, i) {
        const button = buttons[i];
        btn.text = button.text;
        btn.image = button.image;
        btn.click = button.click;
    }
    this.add = function(button) {
        buttons.push(button);
    };
    this.construct = function(width, height, isHorizontal) {
        const cnt = buttons.length;
        const btns = [];
        if(isHorizontal) {
            // Place the buttons across the bottom of the screen.
            const hspacing = 8;
            const vspacing = 4;
            const w1 = (width - (hspacing * (cnt + 1))) / cnt;
            const h1 = 24;
            const y = vspacing;

            let left = hspacing;
            for(let i = 0; i < cnt; i++) {
                const btn = new Button();
                btn.bounds = new Rectangle(left, y, w1, h1);
                initButton(btn, i);
                btns.push(btn);
                left += (w1 + hspacing);
            }
        } else {
            const x = (width * 3) / 4;
            const w = width - x;

            const h1 = height / cnt;

            let top = 0;
            for(let i = 0; i < cnt; i++) {
                const btn = new Button();
                btn.bounds = new Rectangle(x, top, w, h1);
                initButton(btn, i);
                btns.push(btn);
                top += h1;
            }
        }
        return btns;
    };
}


//signature additional fields = it.comped.jdigitalsign.medas.viewer.wizard.FormSignData.FieldType = 'text', 'password'
//form fields = all other
//form fields = def.label || def.name, signature fields = def.description || def.name
const createControl = function(parent, rules, def, template) {
    if(!template) {
        template = {
            rowClass: 'control-group',
            controlClass: 'form-control',
            labelClass: 'control-label',
            buttonClass: 'form-control',
        };
    }
    const id = '__field__' + def.name;
    const row = $(`<div class="${template.rowClass}"></div>`).appendTo(parent);
    let input = null;
    const label = def.label || def.description || def.name;
    let hasLabel = true;
    const rule = {
        required: (typeof (def.required) == 'string') ? (def.required == 'true') : !!def.required,
    };
    const autocomplete = def.autocomplete;
    const _autocomplete = function(_input, _default) {
        let autocomplete0 = autocomplete;
        if((autocomplete0 === null) || (autocomplete0 === undefined)) {
            if(!_default) return;
            autocomplete0 = _default;
        }
        if((autocomplete0 === true)
            || (autocomplete0 === false)
            || (autocomplete0 === 'true')
            || (autocomplete0 === 'false')) {
            autocomplete0 = (typeof (autocomplete0) === 'string') ? (autocomplete0 === 'true') : !!autocomplete0;
            autocomplete0 = autocomplete0 ? 'on' : 'off';
        }
        _input.attr('autocomplete', autocomplete0);
    };

    switch(def.type) {
        case 'Text':
        case 'text':
            input = $(`<input type="text" class="${template.controlClass}"/>`).appendTo(row);
            input.attr('name', id);
            _autocomplete(input);
            break;
        case 'Password':
        case 'password':
            {
                input = $(`\
<div class="input-group">
<input type="password" class="${template.controlClass}"/>
<span class="input-group-addon" style="cursor: pointer;">
<i class="fa fa-eye" aria-hidden="true"></i>
</span>
</div>`).appendTo(row);
                const text = input.find('input');
                text.attr('name', id);
                _autocomplete(text, 'off');
                const button = input.find('span');
                const icon = button.find('i');
                button.on('click', function() {
                    if(text.attr('type') == 'password') {
                        text.attr('type', 'text');
                        icon.removeClass('fa-eye').addClass('fa-eye-slash');
                    } else {
                        text.attr('type', 'password');
                        icon.removeClass('fa-eye-slash').addClass('fa-eye');
                    }
                });
            }
            break;
        case 'TextMultiline':
            input = $(`<textarea rows="2" class="${template.controlClass}"></textarea>`).appendTo(row);
            input.attr('name', id);
            _autocomplete(input);
            break;
        case 'Date':
            // eslint-disable-next-line @stylistic/max-len
            input = $(`<div class="input-group datetime date"><input type="text" class="${template.controlClass}"/><span class="input-group-addon"><span class="fa fa-calendar"></span></span></div>`).appendTo(row);
            input.find('input').attr('name', id);
            input.datetimepicker({
                format: 'L',
                timeZone: 'Etc/UTC',
            });
            break;
        case 'Time':
            // eslint-disable-next-line @stylistic/max-len
            input = $(`<div class="input-group datetime time"><input type="text" class="${template.controlClass}"/><span class="input-group-addon"><span class="fa fa-clock-o"></span></span></div>`).appendTo(row);
            input.find('input').attr('name', id);
            input.datetimepicker({
                format: 'LTS',
                timeZone: 'Etc/UTC',
            });
            break;
        case 'DateTime':
            // eslint-disable-next-line @stylistic/max-len
            input = $(`<div class="input-group datetime date-time"><input type="text" class="${template.controlClass}"/><span class="input-group-addon"><span class="fa fa-calendar"></span></span></div>`).appendTo(row);
            input.find('input').attr('name', id);
            input.datetimepicker({
                format: 'L LTS',
            });
            break;
        case 'Number':
            input = $(`<input type="text" class="${template.controlClass}"/>`).appendTo(row);
            input.attr('name', id);
            _autocomplete(input);
            rule.number = true;
            break;
        case 'CheckBox':
            input = $('<div class="checkbox"><label><input type="checkbox"/><span></span></label></div>').appendTo(row);
            input.find('input').attr('name', id);
            input.find('span').text(label);
            hasLabel = false;
            break;
        case 'RadioGroup':
            {
                input = $('<div class="panel panel-default"><div class="panel-heading"></div><div class="panel-body"></div></div>').appendTo(row);
                input.find('.panel-heading').text(label);
                const grp = input.find('.panel-body');
                for(let i = 0; i < def.values.length; i++) {
                    const val = def.values[i];
                    const radio = $('<div class="radio"><label><input type="radio"/><span></span></label></div>').appendTo(grp);
                    radio.find('span').text(val.display || val.name);
                    radio.find('input').attr('value', val.name).attr('name', id);
                }
                hasLabel = false;
            }
            break;
        case 'ChoiceCombo':
            input = $(`<select class="${template.controlClass}"></select>`).appendTo(row);
            input.attr('name', id);
            for(let i = 0; i < def.values.length; i++) {
                const val = def.values[i];
                const item = $('<option></option>').appendTo(input);
                item.text(val.display || val.name);
                item.attr('value', val.name);
            }
            break;
        case 'ChoiceComboEditable':
            {
                input = $(`<input type="text" class="${template.controlClass}"/>`).appendTo(row);
                input.attr('name', id);
                const options = {
                    items: 'all',
                    minLength: 0,
                    showHintOnFocus: 'all',
                    autoSelect: false,
                    source: [],
                };
                for(let i = 0; i < def.values.length; i++) {
                    const val = def.values[i];
                    options.source.push({ id: val.name, name: val.display || val.name });
                }
                input.typeahead(options);
            }
            break;
        case 'sign-action':
            input = $(`<input type="button" class="${template.buttonClass}" data-type="sign-action"/>`).appendTo(row);
            input.attr('name', id);
            input.val(label);
            input.attr('data-action', def.value);
            input.attr('data-params', def.params && JSON.stringify(def.params));
            hasLabel = false;
            break;
        case 'hidden':
            input = $(`<input type="hidden" class="${template.controlClass}"/>`).appendTo(row);
            input.attr('name', id);
            hasLabel = false;
            break;
    }
    if(!input) {
        row.remove();
        return $();
    }

    if(hasLabel) {
        let lid = id;
        if(!input.is('[name]')) {
            lid = '__label__' + def.name;
            input.find('[name]').attr('id', lid);
        }
        const labelobj = $(`<label class="${template.labelClass}"></label>`).prependTo(row);
        labelobj.attr('for', lid).text(label);
    }

    if(def.default)
        input.cleverVal(def.default);

    let input0 = input.find('[name]');
    if(!input0.length) input0 = input;
    input0.attr('data-name', def.name);
    input.attr('id', id);
    rules[id] = rule;
    return input;
};

const defaultValidator = function(form, rules) {
    const options = {
        rules,
        onsubmit: false,
        onfocusout: false,
        onkeyup: false,
        onclick: false,
        focusInvalid: false,
        focusCleanup: false,
        showErrors(errorMap, errorList) {
            if(!errorList.length)
                return;
            let message = '';
            for(let i = 0; i < errorList.length; i++) {
                const error = errorList[i];
                const div = $(error.element).closest('.control-group,.form-group');
                const label = div.find('label').text();
                if(i)
                    message += '\n';
                message += label + ': ' + error.message;
            }
            tools.scripterr(message);
        },
    };
    return form.validate(options);
};

$.fn.cleverVal = function() {
    const $this = $(this);
    // password eye controls created with createControl are divs with [name]
    let input = $this.find('[name]');
    if(!input.length)
        input = $this.find('[data-name]');
    if(!input.length)
        input = $this;

    let options = {};
    const args = Array.prototype.slice.call(arguments);
    if(args[args.length - 1] && (typeof (args[args.length - 1]) == 'object')) {
        options = args[args.length - 1];
        args.pop();
    }
    if(!args.length) {
        //getter
        let val;
        if(input.is('[type=checkbox]')) {
            val = !!input.prop('checked');
        } else if(input.is('[type=radio]')) {
            val = input.filter(':checked').val();
        } else if($this.is('.datetime')) {
            val = $this.data('DateTimePicker').date();
            if(options.string) {
                if($this.is('.date')) {
                    val = new tools.timeformat(val).toXml({ needTime: false, zone: false });
                } else if($this.is('.time')) {
                    val = val.format('HH:mm:ss');
                } else {
                    val = new tools.timeformat(val).toXml();
                }
            }
        } else if(input.is('[type=button]')) {
            //buttons don't have value
            val = input.attr('data-value');
        } else {
            val = input.val();
        }
        if(options.string)
            val = String(val);
        return val;
    }
    //setter
    let val = args[0];
    if(input.is('[type=checkbox]')) {
        input.prop('checked', (typeof (val) == 'string') ? (val == 'true') : !!val);
    } else if(input.is('[type=radio]')) {
        input.prop('checked', false);
        if(val)
            input.filter(function() { return $(this).val() == val; }).prop('checked', true);
    } else if($this.is('.datetime')) {
        if(val && (typeof (val) == 'string')) {
            const options2 = {};
            if(/^\d{2}:\d{2}:\d{2}/.test(val)) {
                val = moment().format('YYYY-MM-DD[T]') + val;
                options2.forceUtc = true;
            }
            val = new tools.timeformat(val, options2).toMoment();
            if($this.is('.date-time'))
                val.local();
        }
        $this.data('DateTimePicker').date(val || null);
    } else if(input.is('[type=button]')) {
        //buttons don't have value
        input.attr('data-value', val);
    } else {
        input.val(val);
    }
    return undefined;
};


const utils = {
    FILTER_WACOM,
    FILTER_MOUSE,
    FILTER_PEN,
    FILTER_TOUCH,
    FILTER_WACOM_EXT,
    FILTER_POINTER,
    FILTER_POINTER_ALL_INTERNAL,
    FILTER_ALL,
    getFilterString,
    PreserveVariables,
    ImageUrl,
    Rectangle,
    Button,
    Point,
    Buttons,
    createControl,
    defaultValidator,
};
export default utils;
